import { Component, ComponentFactoryResolver, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GlobalServices } from '../global.services';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../api.service';
import { NgbDatepickerConfig, NgbCalendar, NgbDate, NgbDateStruct, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { baseUrls } from '../appConstant';

@Component({
  templateUrl: './partnersignup.component.html',
  styleUrls: ['./partnersignup.component.scss']
})
export class PartnersignupComponent implements OnInit {
  mode = 'determinate';
  public registerFormPartener: FormGroup;
  public submitted: boolean = false;
  public titleOptions = [{ label: 'Mr.', value: 'Mr.' }, { label: 'Ms.', value: 'Ms.' }, { label: 'Mrs.', value: 'Mrs.' }, { label: 'Dr.', value: 'Dr.' }];
  public resMsg: string;
  public condMsg: string = '';
  public parDiv: any;
  public childDiv: any;
  public count: number = 0;
  public countryData: any;
  public cameFrom: string = "";
  public countryId: string;
  public genderVlaue: any;
  public categoryData: any;
  public model: NgbDateStruct;
  public globalurl = baseUrls['global'];
  public date: { year: number, month: number };
  public dateValue: string;
  public showAlert = false;
  public responseMessage = '';
  dropdownList = [];
  selectedCategories = [];
  selectedCategoriesId = [];
  dropdownSettings: IDropdownSettings;
  @ViewChild('registerProfileUserImage', { static: true }) registerProfileUserImage: ElementRef;
  @ViewChild('registerProfilePartenerImage', { static: true }) registerProfilePartenerImage: ElementRef;

  constructor(public globalServices: GlobalServices, public cfr: ComponentFactoryResolver, private httpService: ApiService, public calendar: NgbCalendar, public config: NgbDatepickerConfig, public router: Router, public formBuilder: FormBuilder,) { }

  ngOnInit() {
    if (this.globalServices?.isBrowser) {
      this.globalServices?.hideHeader.next(false);
      this.globalServices?.hideFooter.next(false);
      this.loadRegisterFormPartener();
    }
  }

  get formData() {
    return this.registerFormPartener.controls;
  }

  loadRegisterFormPartener() {
    if (this.globalServices.isBrowser) {
      let url = "global/program/category";
      this.httpService.getData(url).subscribe(response => {
        this.categoryData = response['data'];
        this.dropdownList = [];
        this.categoryData.forEach(el => {
          this.dropdownList.push({
            item_id: el._id,
            item_text: el.name
          });
        });
        // console.log(this.dropdownList);
        this.dropdownSettings = {
          singleSelection: false,
          idField: 'item_id',
          textField: 'item_text',
          itemsShowLimit: 3,
          limitSelection: 3,
          allowSearchFilter: true
        };

      });

      const urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
      this.registerFormPartener = this.formBuilder.group({
        title: ["", Validators.required],
        companyName: ["", Validators.required],
        firstName: ["", Validators.required],
        lastName: ["", Validators.required],
        position: ["", Validators.required],
        categories: ["", Validators.required],
        termsofservice: [""],
        website: ["", [Validators.required, Validators.pattern(urlRegex)]],
        email: ["", [Validators.required, Validators.email, this.emailDomainValidator]],
        mobile: ["", Validators.required],
        about: [""],
        programCategory: [""],
        profileImage: [""]
      });
    }
  }

  emailDomainValidator(control: FormControl) {
    let email = control.value;
    if (email && email.indexOf("@") != -1) {
      let [_, domain] = email.split("@");
      if (domain.length < 5) {
        return {
          emailDomain: {
            parsedDomain: domain
          }
        }
      } else {
        if (domain && domain.indexOf(".") != -1) {
          let [before, after] = domain.split(".");
          if (before.length < 2) {
            return {
              emailDomain: {
                parsedDomain: domain
              }
            }
          } else if (after.length < 2) {
            return {
              emailDomain: {
                parsedDomain: domain
              }
            }
          } else {
            return null;
          }
        } else {
          return {
            emailDomain: {
              parsedDomain: domain
            }
          }
        }
      }
    }
    return null;
  }

  public onSubmitPartenerFrom() {
    if (this.globalServices.isBrowser) {
      this.registerFormPartener.patchValue({
        programCategory: this.selectedCategoriesId.join('###')
      });
      this.errorMessageEmail = '';
      this.condMsg = '';
      this.submitted = true;
      const ele = document.getElementById("checkCondition") as HTMLInputElement;
      // console.log(this.selectedCategories, this.registerFormPartener);
      if (this.registerFormPartener.invalid) {
        return;
      } else {
        this.mode = 'indeterminate';
        let url = "vendor/signup";
        console.log("1", this.toFormData(this.registerFormPartener.value));
        console.log("1", this.registerFormPartener.value);
        this.httpService.postFormData(url, this.registerFormPartener.value).subscribe((response: any) => {
          this.submitted = false;
          if (response.success) {
            this.mode = 'determinate';
            document.getElementById("signup-popup").style.display = "none";
            // this.registerFormPartener.reset();
            this.fileUploadImageSrc = "";
            this.fileUploadImageSrcVendor = "";
            this.resMsg = response.message;
            this.responseMessage = response.message;
            this.showAlert = true;
            setTimeout(() => {
              this.showAlert = false;
            }, 3000);
          } else {
            if (response['statusCode'] == "01") {
              this.errorMessageEmail = response['message'];
              this.mode = 'determinate';
              // document.getElementById("signup-popup").style.display = "none";
            }
          }
        });
      }
    }
  }


  public errorMessageEmail: string = '';     // to show error in case of signup for email field
  toFormData<T>(formValue: T) {
    const formData = new FormData();
    for (const key of Object.keys(formValue)) {
      const value = formValue[key];
      formData.append(key, value);
    }
    return formData;
  }
  fileUploadImageSrc;
  fileUploadImageSrcVendor;
  // Image Upload
  showCalendar: boolean = false;
  upfilename = '';
  getFile2(event) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      let allowed_extensions = new Array("jpg", "png", "jpeg", "JPEG", "JPG", "PNG");
      let file_extension = event.target.files[0]['name'].split('.').pop();
      if (allowed_extensions.indexOf(file_extension) < 0) {
        alert("Only image is allowed");
        return;
      }
      reader.readAsDataURL(event.target.files[0]);
      // save Data to API********************************************************


      if (event.target.files[0]) {

        if (event && event.target && event.target.files && event.target.files.length > 0) {
          var file = event.target.files[0];
          var self = this;
          reader.onloadend = function () {
            self.fileUploadImageSrcVendor = reader.result;
          }
        }
        this.registerFormPartener.controls['profileImage'].setValue(event.target.files[0]);
      }
    }
    this.upfilename = event.target.files[0].name;
    // console.log(event);
  }

  public closePopup(): void {
    if (this.globalServices.isBrowser) {
      this.registerProfileUserImage ? this.registerProfileUserImage.nativeElement.value = "" : '';
      this.registerProfileUserImage ? this.registerProfilePartenerImage.nativeElement.value = "" : '';
      this.resMsg = '';
      this.fileUploadImageSrc = "";
      this.fileUploadImageSrcVendor = "";
      document.getElementById("sign-up-form").style.display = "block";
      this.submitted = false;
      // this.loadRegisterFormUser();
      this.registerFormPartener.patchValue({
        programCategory: '',
        title: '',
        companyName: '',
        firstName: '',
        lastName: '',
        position: '',
        categories: '',
        termsofservice: '',
        website: '',
        email: '',
        mobile: '',
        about: '',
        profileImage: '',
      });
      this.selectedCategories = [];
      this.selectedCategoriesId = [];
      // this.loadRegisterFormPartener();
    }
  }



  closecomponent(): void {
    this.globalServices.viewcontainerhelper.clear();
  }

  closecomponentandlogin() {
    // this.globalServices.cameFrom = 'partner';
    this.globalServices.triggerlogin(this.globalServices.viewcontainerhelper, this.cfr);
  }

  onItemSelect(item: any) {
    // console.log(item);
    this.selectedCategories.push(item);
    this.selectedCategoriesId.push(item.item_id);
  }

  public triggerCloseEvent() {
    this.showAlert = false;
  }

}
